import React from 'react';
import {
  Form, Input, Checkbox, Select, Spin, Icon, Skeleton, Avatar, Row, Col, Button,
} from 'antd';
import moment from 'moment';
import {
  Box, Text,
} from '../../shared/components';
import InlineCard from '../components/InlineCard';

const { Option } = Select;
const { TextArea } = Input;

export default function DatosTab({
  usuarioNombre, usuarioId, form, sedes, noConformidades, onChangeSede, history, setMostrarBarraBotonesFormNcAction,
}) {
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  const { getFieldDecorator } = form;
  const { listado: listadoSedes, loading: loadingSedes } = sedes;
  const { seleccionada } = noConformidades;
  const {
    id, nombre, observaciones, sede, coste, sensible, reincidencia,
    revisar_riesgos_y_oportunidades: revisarRiesgosYOportunidades,
    requiere_cambios_sistema_gestion: requiereCambiosSistemaGestion,
    lote_producto: loteProducto, lote_proveedor: loteProveedor,
    unidades_afectadas: unidadesAfectadas, creado_por_str: creadoPorStr,
    creado_por: creadoPor, fecha_creacion: fechaCreacion,
    observaciones_web: observacionesWeb,
  } = seleccionada || null;

  let fechaCreacionAux = null;
  if (fechaCreacion) {
    fechaCreacionAux = fechaCreacion;
  }
  const esEditableObs = !observacionesWeb;
  let observacionesSinImg = '';
  let imgObservaciones = '';
  let arrayImgs = null;
  if (observaciones) {
    const posImgObservaciones = observaciones.indexOf('<img');
    if (posImgObservaciones >= 0) {
      observacionesSinImg = observaciones.slice(0, posImgObservaciones).replace(/<br><br> /g, '');
      imgObservaciones = observaciones.slice(posImgObservaciones, observaciones.length);
    } else {
      observacionesSinImg = observaciones;
    }
    imgObservaciones = imgObservaciones.replace(/<br><br> /g, '');
    arrayImgs = imgObservaciones.split('<img src="');
    if (arrayImgs && (arrayImgs.length > 0)
       && ((arrayImgs[0] === ' ') || (arrayImgs[0] === ''))) {
      arrayImgs.splice(0, 1);
    }
  }

  const nombreUsuario = creadoPorStr || usuarioNombre;
  const mostrarImgAdjuntas = (typeof (id) !== 'undefined') ? 'visible' : 'none';

  return (
    <Box>
      <InlineCard
        headerText="PERFIL"
        content={(
          <Box style={{
            display: 'flex',
            marginBottom: '0px',
          }}
          >
            <Box style={{
              marginBottom: '0px',
            }}
            >
              <Avatar
                style={{
                  color: '#2E384D',
                  backgroundColor: 'white',
                  border: '1px solid #2E384D',
                  height: '48px',
                  width: '48px',
                  fontSize: '28px',
                  textAlign: 'center',
                  padding: '5px',
                }}
              >
                {' '}
                {nombreUsuario.charAt(0)}
              </Avatar>
            </Box>
            <Box style={{
              display: 'inline-block',
              textAlign: 'left',
              marginLeft: '8px',
            }}
            >
              <Text style={{
                color: '#2E384D',
                fontFamily: 'Rubik',
                fontSize: '15px',
                fontWeight: '650',
                lineHeight: '22px',
              }}
              >
                {creadoPorStr || usuarioNombre}
              </Text>
              <br />
              <Text
                id="fecha_creacion"
                style={{
                  color: '#8798AD',
                  fontFamily: 'Rubik',
                  fontSize: '15px',
                  lineHeight: '22px',
                }}
              >
                {(fechaCreacionAux || moment().format('DD/MM/YYYY'))}
              </Text>
              <Form.Item style={{ display: 'none' }}>
                {getFieldDecorator('fecha_creacion', {
                  initialValue: ((fechaCreacionAux) || moment().format('DD/MM/YYYY')),
                })(
                  <Text
                    id="fecha_creacion"
                    style={{
                      color: '#8798AD',
                      fontFamily: 'Rubik',
                      fontSize: '15px',
                      lineHeight: '22px',
                      display: 'none',
                    }}
                  >
                    {(fechaCreacionAux || moment().format('DD/MM/YYYY'))}
                  </Text>,
                )}
              </Form.Item>
            </Box>
          </Box>
        )}
      />
      <InlineCard
        headerText="INFORMACIÓN BÁSICA"
        content={(
          <Box>
            <Form.Item style={{ display: 'none' }}>
              {getFieldDecorator('id', {
                initialValue: id,
                preserve: true,
              })(
                <Text style={{ display: 'none' }} id="id" />,
              )}
            </Form.Item>

            <Form.Item style={{ display: 'none' }}>
              {getFieldDecorator('usuario_id', {
                initialValue: creadoPor || usuarioId,
                preserve: true,
              })(
                <Text style={{ display: 'none', visibility: 'hidden' }} id="usuario_id" />,
              )}
            </Form.Item>

            <Form.Item required={false} label="NOMBRE">
              {getFieldDecorator('nombre', {
                initialValue: nombre,
                rules: [{ required: true, message: 'Introduzca el nombre', whitespace: true }],
              })(
                <Input
                  onFocus={() => setMostrarBarraBotonesFormNcAction(false)}
                  onBlur={() => setMostrarBarraBotonesFormNcAction(true)}
                  placeholder=""
                  id="nombre"
                />,
              )}
            </Form.Item>

            <Form.Item label="DESCRIPICIÓN">
              {getFieldDecorator('observaciones', {
                initialValue: observacionesSinImg,
              })(
                (!esEditableObs)
                  ? (<div style={{ resize: 'both', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: observacionesSinImg }} />)
                  : (
                    <TextArea
                      onFocus={() => setMostrarBarraBotonesFormNcAction(false)}
                      onBlur={() => setMostrarBarraBotonesFormNcAction(true)}
                      placeholder=""
                      id="observaciones"
                      autosize={{ minRows: 2, maxRows: 10 }}
                    />
                  ),
              )}
            </Form.Item>

            <Form.Item style={{ display: 'none' }} label="Fotos3">
              {getFieldDecorator('observaciones_web', {
                initialValue: observacionesWeb,
                preserve: true,
              })(
                <Text style={{ display: 'none' }} id="observaciones_web" />,
              )}
            </Form.Item>

            <Form.Item style={{ display: 'none' }} label="Fotos2">
              {getFieldDecorator('observaciones_fotos', {
                initialValue: imgObservaciones,
                preserve: true,
              })(
                (<div style={{ resize: 'both', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: imgObservaciones }} />),
              )}
            </Form.Item>
            {id && (arrayImgs.length > 0) ? (
              <Form.Item label="IMÁGENES ADJUNTAS">
                {getFieldDecorator('observaciones_fotos_galeria', {
                })(

                  (
                    <Row gutter={16} type="flex" justify="space-between" align="middle">
                      {arrayImgs ? (arrayImgs.map((item, i) => (
                        <Col
                          span={8}
                          key={item}
                          value={item}
                          style={{ marginBottom: '10px' }}
                        >

                          <Avatar
                            shape="square"
                            size={80}
                            src={item ? item.replace('<br><br>', '').replace('" alt="" />', '').replace('" />', '') : ''}
                            onClick={() => history.push(`/noconformidades/${id}/fotos/${i}`)}
                          />
                        </Col>
                      ))) : ''}
                    </Row>),

                )}
              </Form.Item>
            ) : ''}


            <Form.Item label="SEDE">
              {getFieldDecorator('sede', {
                initialValue: (sede || 1),
              })(
                <Select
                  showSearch
                  placeholder="Seleccione una sede"
                  optionFilterProp="sede"
                  onChange={(value) => {
                    onChangeSede(value);
                  }}
                  onFocus={() => setMostrarBarraBotonesFormNcAction(false)}
                  onBlur={() => setMostrarBarraBotonesFormNcAction(true)}
                  notFoundContent={loadingSedes ? <Spin style={{ marginLeft: '45%' }} indicator={antIcon} size="small" /> : null}
                  filterOption={
                      (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >

                  {listadoSedes.map(item => (
                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                  ))}

                </Select>,
              )}

            </Form.Item>
            <Form.Item label="COSTE">
              {getFieldDecorator('coste', {
                initialValue: coste,
              })(
                <Input
                  onFocus={() => setMostrarBarraBotonesFormNcAction(false)}
                  onBlur={() => setMostrarBarraBotonesFormNcAction(true)}
                  placeholder=""
                  id="coste"
                />,
              )}
            </Form.Item>
          </Box>
                )}
      />
      <InlineCard
        headerText="MARCAR COMO"
        content={(
          <Box>
            <Form.Item>
              {getFieldDecorator('checkbox_sensible', {
                initialValue: sensible,
                valuePropName: 'checked',
              })(
                <Checkbox>Registro sensible</Checkbox>,
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator('reincidencia', {
                initialValue: reincidencia,
                valuePropName: 'checked',
              })(
                <Checkbox>Reincidencia</Checkbox>,
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator('revisar_riesgos_y_oportunidades', {
                initialValue: revisarRiesgosYOportunidades,
                valuePropName: 'checked',
              })(
                <Checkbox>Revisar riesgos y oportunidades</Checkbox>,
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator('requiere_cambios_sistema_gestion', {
                initialValue: requiereCambiosSistemaGestion,
                valuePropName: 'checked',
              })(
                <Checkbox>Requiere cambios en el sistema de gestión</Checkbox>,
              )}
            </Form.Item>

          </Box>
              )}
      />
      <InlineCard
        headerText="PRODUCTO"
        content={(
          <Box>
            <Form.Item label="LOTE PRODUCTO">
              {getFieldDecorator('lote_producto', {
                initialValue: loteProducto || null,
              })(
                <Input
                  onFocus={() => setMostrarBarraBotonesFormNcAction(false)}
                  onBlur={() => setMostrarBarraBotonesFormNcAction(true)}
                  placeholder=""
                  id="loteProducto"
                />,
              )}
            </Form.Item>

            <Form.Item label="LOTE PROVEEDOR">
              {getFieldDecorator('lote_proveedor', {
                initialValue: loteProveedor || null,
              })(
                <Input
                  onFocus={() => setMostrarBarraBotonesFormNcAction(false)}
                  onBlur={() => setMostrarBarraBotonesFormNcAction(true)}
                  placeholder=""
                  id="loteProveedor"
                />,
              )}
            </Form.Item>
            <Form.Item label="UNIDADES AFECTADAS">
              {getFieldDecorator('unidades_afectadas', {
                initialValue: unidadesAfectadas || null,
              })(
                <Input
                  onFocus={() => setMostrarBarraBotonesFormNcAction(false)}
                  onBlur={() => setMostrarBarraBotonesFormNcAction(true)}
                  placeholder=""
                  id="unidadesAfectadas"
                />,
              )}

            </Form.Item>
          </Box>
                )}
      />
    </Box>
  );
}
